module.exports = __webpack_public_path__ + "static/media/bg10.0f99a8a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minibg/bg10.jpg
// module id = 592
// module chunks = 0